import { BootcampMentor } from "@/schemaTypes";
import { Box, Divider, Flex, Stack, Text } from "@chakra-ui/react";

interface MentorsListProps {
  mentors: BootcampMentor[];
}

export const MentorsList: React.FC<MentorsListProps> = ({ mentors }) => {
  return (
    <Box
      borderRadius="6px"
      border="1px solid"
      borderColor="neutral.100"
      p={4}
      bg="white"
    >
      <Stack spacing={3} divider={<Divider borderColor="#E2E8F0" />}>
        {mentors.map((mentor, idx) => (
          <Flex key={idx} align="center" gap={4}>
            <Box
              boxSize="48px"
              borderRadius="full"
              backgroundImage={`url(${
                mentor.profilePicture ||
                "https://ui-avatars.com/api/?name=Mentor"
              })`}
              backgroundSize="cover"
              backgroundPosition="center top"
              backgroundRepeat="no-repeat"
              opacity={0.8}
            />
            <Box>
              <Text
                fontWeight={600}
                fontSize="14px"
                fontFamily="Inter"
                color="secondary.300"
              >
                {mentor.name} {mentor.lastName}
              </Text>
              <Text
                fontWeight={500}
                fontSize="12px"
                fontFamily="Inter"
                color="secondary.300"
              >
                {mentor.jobtitle}
              </Text>
            </Box>
          </Flex>
        ))}
      </Stack>
    </Box>
  );
};
